module.exports = __webpack_public_path__ + "static/media/barbecue1.dc9014ee.jpg";